import { ref } from 'vue'

export const PER_PAGE = 10
export const PER_PAGE_NOT_PAGINATED = 100

export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  CUSTOMER = 'customer',
  OPERATOR = 'operator'
}

export const weekDays = ref([
  { key: 'Lunedì', value: 1 },
  { key: 'Martedì', value: 2 },
  { key: 'Mercoledì', value: 3 },
  { key: 'Giovedì', value: 4 },
  { key: 'Venerdì', value: 5 },
  { key: 'Sabato', value: 6 },
  { key: 'Domenica', value: 0 },
  { key: 'Ultimo giorno del mese', value: 7 }
])
